// Microsoft Clarity Implementation
declare global {
  interface Window {
    clarity: (...args: any[]) => void;
  }
}

export const CLARITY_PROJECT_ID = import.meta.env.VITE_CLARITY_PROJECT_ID;

export const initClarity = () => {
  if (typeof window !== 'undefined' && CLARITY_PROJECT_ID) {
    console.log('[Clarity] Initializing Microsoft Clarity:', CLARITY_PROJECT_ID);
    (function(c: any, l: any, a: any, r: any, i: any, t: any, y: any) {
      c[a] = c[a] || function() {
        (c[a].q = c[a].q || []).push(arguments);
      };
      t = l.createElement(r);
      t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", CLARITY_PROJECT_ID);
  } else if (typeof window !== 'undefined') {
    console.log('[Clarity] Not initialized - VITE_CLARITY_PROJECT_ID not set');
  }
};

export const identifyClarityUser = (userId: string, userEmail?: string) => {
  if (typeof window !== 'undefined' && window.clarity) {
    window.clarity('identify', userId, {
      email: userEmail,
    });
  }
};

export const tagClaritySession = (key: string, value: string) => {
  if (typeof window !== 'undefined' && window.clarity) {
    window.clarity('set', key, value);
  }
};
